import { z } from 'zod';
// `action` reste une chaîne libre (pas un enum Zod) — voir le commentaire sur le modèle AuditLog
// dans schema.prisma : un nouveau type d'événement ne doit jamais nécessiter de toucher ce schéma.
export const AuditLogEntryDTO = z.object({
    id: z.string(),
    action: z.string(),
    createdByEmail: z.string(),
    repoId: z.string().nullable(),
    repoPathWithNamespace: z.string().nullable(),
    metadata: z.record(z.string(), z.unknown()).nullable(),
    createdAt: z.string(),
});
export const AuditLogResponse = z.object({
    entries: z.array(AuditLogEntryDTO),
    page: z.number(),
    totalPages: z.number(),
    totalCount: z.number(),
});
const CountEntry = z.object({ label: z.string(), count: z.number() });
export const AuditLogStatsResponse = z.object({
    // Un point par jour sur la fenêtre — jours sans événement inclus à 0 (pas de trou dans le
    // graphe), calculé côté API pour ne pas dupliquer cette logique dans chaque client.
    eventsPerDay: z.array(z.object({ date: z.string(), count: z.number() })),
    byAction: z.array(CountEntry),
    topUsers: z.array(CountEntry),
    topRepos: z.array(CountEntry),
});
//# sourceMappingURL=auditLog.js.map